// Move the dropdown menu arrow to always be centered with the text of the link the user hovered over
let cached_stylesheet = null;
const updated_arrows = {};
const positionDropdownArrows = (thisElement, sublistElement) => {
  const id = sublistElement.id;

  if (!updated_arrows[id]) {
    updated_arrows[id] = true;
    const linkWidth = thisElement.querySelector('a').offsetWidth / 2;

    // jQuery can't access :before since it's not part of the DOM.
    // But...we can just add a rule to the stylesheet itself.
    if (!cached_stylesheet) {
      Array.from(document.styleSheets).forEach((stylesheet) => {
        if (stylesheet.ownerNode.getAttribute('id') === 'navDropdowns') {
          cached_stylesheet = stylesheet;
        }
      });
    }

    const rules = cached_stylesheet.cssRules || cached_stylesheet.rules;
    const ruleIndex = Array.from(rules).findIndex((rule) => rule.selectorText === `#${id}:before`);
    if (ruleIndex !== -1) {
      cached_stylesheet.deleteRule(ruleIndex);
    }
    cached_stylesheet.insertRule(`#${id}:before { left: ${linkWidth}px; }`, rules.length);
  }
};

export default function () {
  // Set max-height on dropdown hover to trigger animation and open dropdown
  document.addEventListener(
    'mouseenter',
    (e) => {
      // Ensure e.target is an Element before calling closest
      if (e.target instanceof Element) {
        const target = e.target.closest('[data-nav-dropdown-hover]');
        if (target) {
          const thisElement = target;
          const dropdown = thisElement.querySelector('[data-nav-dropdown]');
          const sublist = dropdown.querySelector('[data-nav-sublist]');

          positionDropdownArrows(thisElement, sublist);

          // sublist.offsetTop gets the triangle height
          const maxHeight = sublist.offsetHeight + sublist.offsetTop;
          dropdown.style.maxHeight = `${maxHeight}px`;
        }
      }
    },
    true,
  );

  // Unset max-height to close dropdown
  document.addEventListener(
    'mouseleave',
    (e) => {
      // Ensure e.target is an Element before calling closest
      if (e.target instanceof Element) {
        const target = e.target.closest('[data-nav-dropdown-hover]');
        if (target) {
          const dropdown = target.querySelector('[data-nav-dropdown]');
          dropdown.style.maxHeight = '0';
        }
      }
    },
    true,
  );
}
